define([
	"dojo/_base/declare",
	"csi/gallery/Widget",
], function(declare, Widget) {

	// attribute ids that should be omitted from filtering
	var _omit = {
		// General
		Colors: 1,
		LocalizedName: 1,
		"Node Name": 1,
		State: 1,

		// MarketingCollection
		BaseCurrency: 1,
		CurrencyExchangeTable: 1,
		Materials: 1,
		Products: 1,
		Segments: 1,

		// MCMaterial
		MCMaterial: 1,

		// MCProduct
		ProductStyle: 1,

		// MCProductToCustomer
		Brands: 1,
		Features: 1,
		MainMaterial: 1,
		MarketingSegment: 1,
		MCProductSizes: 1,
		MCSizeRange: 1,

		// SMProduct
		Looks: 1,
		MasterProduct: 1,
		OriginalSalesCollection: 1,
		OriginalSalesCollectionRollDown: 1
	};

	return declare(Widget, {
		customViewOptionsComponent: null,
		disableCustomViewToolbar: true,
		plugins: ["CustomViewManageButton", "CustomViewSelect", "filter"],

		// String: specify empty context to override default Html view context so that Catalog view will find default
		prefViewContext: "",

		// Boolean: indicate we only want to work with shared custom views
		prefSiteOnly: true,

		/**
		 * @override
		 * Disallow some attributes and only allow attributes that support filtering
		 */
		onCustomViewAttributeOptions(options) {
			options.omitAttributeCallback = ({id}) => !id || _omit[id];
			options.filterOnly = true;
			this.inherited(arguments);
		},

		/**
		 * @override
		 * Custom views are enabled even though disabling standard custom view toolbar controls
		 */
		supportsCustomViews: function() {
			return true;
		}
	});
});